import { render, staticRenderFns } from "./InvestorEventsView.vue?vue&type=template&id=451538ea&scoped=true"
import script from "./InvestorEventsView.vue?vue&type=script&lang=js"
export * from "./InvestorEventsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451538ea",
  null
  
)

export default component.exports